import React from "react";
import BoardHeader from "./BoardHeader";
import { useSelector } from "react-redux";
import BoardBody from "./BoardBody";
import ScoutObservationList from "../../ScoutObservation/ScoutObservationList";
import { usePermission } from "../../../helpers/common";

const Board = () => {
    const activeTab = useSelector(state => state.scoutKanban.activeTab);
    const allow = usePermission();
    const isFieldGroup = allow("field-grouping", "view");

    return (
        <div className="crew-kanban-container scout_kanban_container">
            {isFieldGroup ? <BoardHeader /> : null}
            {activeTab === "scout" ? <BoardBody /> : null}
            {activeTab === "observation" ? <ScoutObservationList /> : null}
        </div>
    );
}


export default Board;